import { cn } from '@/_lib/utils'

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('animate-pulse rounded-md bg-brand-grayscale-4', className)} {...props} />
  )
}

export { Skeleton }
